import { FoodModel } from 'src/app/core/model/object/diet-food-model';
export class FoodLogModel {
  constructor(
    public amount: number,
    public date: number,
    public food: string,
    public meal: string,
    public unit: string,
    public user: string,
    public foodModel: FoodModel,
    public _id: string,
    public calorie?: number,
    public title?: string
  ) {}
}

export class DietDayFoodLogsModel {
  constructor(
    public foodLogs: FoodLogModel[],
    public date: number,
    public updatedAt: number
  ) {}
}
